import React from 'react';
import { Award, CheckCircle, Calendar } from 'lucide-react';
import { Button } from './ui/Button';
interface ISOCertificateCardProps {
  code: string;
  title: string;
  certNumber: string;
  expiryDate: string;
  scope: string;
}
export function ISOCertificateCard({
  code,
  title,
  certNumber,
  expiryDate,
  scope
}: ISOCertificateCardProps) {
  return <article className="bg-white border border-wkm-slate-200 rounded-xl p-6 relative overflow-hidden hover:border-wkm-gold-300 hover:shadow-xl transition-all duration-300 group" data-id="element-31">
      <div className="absolute top-0 right-0 p-4 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-32">
        <Award className="w-32 h-32 text-wkm-navy-900" data-id="element-33" />
      </div>

      <div className="relative z-10" data-id="element-34">
        <div className="flex items-center mb-4" data-id="element-35">
          <div className="w-12 h-12 bg-wkm-gold-50 text-wkm-gold-600 rounded-lg flex items-center justify-center font-bold text-xl border border-wkm-gold-200 mr-4 flex-shrink-0" data-id="element-36">
            ISO
          </div>
          <div className="min-w-0" data-id="element-37">
            <h3 className="text-xl font-bold text-wkm-navy-900 truncate" data-id="element-38">
              {code}
            </h3>
            <p className="text-wkm-slate-500 text-sm truncate" data-id="element-39">{title}</p>
          </div>
        </div>

        <dl className="space-y-3 mb-6" data-id="element-40">
          <div className="flex items-start text-sm" data-id="element-41">
            <dt className="text-wkm-slate-400 w-24 flex-shrink-0" data-id="element-42">Cert No.</dt>
            <dd className="font-mono text-wkm-slate-700 break-all" data-id="element-43">
              {certNumber}
            </dd>
          </div>
          <div className="flex items-start text-sm" data-id="element-44">
            <dt className="text-wkm-slate-400 w-24 flex-shrink-0" data-id="element-45">Expiry</dt>
            <dd className="text-wkm-slate-700 flex items-center" data-id="element-46">
              <Calendar className="w-3 h-3 mr-1.5 text-wkm-slate-400 flex-shrink-0" data-id="element-47" />
              {expiryDate}
            </dd>
          </div>
          <div className="flex items-start text-sm" data-id="element-48">
            <dt className="text-wkm-slate-400 w-24 flex-shrink-0" data-id="element-49">Scope</dt>
            <dd className="text-wkm-slate-700 line-clamp-2" title={scope} data-id="element-50">
              {scope}
            </dd>
          </div>
        </dl>

        <Button variant="outline" size="sm" fullWidth className="group-hover:border-wkm-gold-500 group-hover:text-wkm-gold-600 transition-colors" data-id="element-51">
          <CheckCircle className="w-4 h-4 mr-2 text-green-500" data-id="element-52" />
          Lihat Sertifikat
        </Button>
      </div>
    </article>;
}